"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMAIL_PAYLOAD = void 0;
exports.EMAIL_PAYLOAD = {
    CUSTOM_TEXT_EMAIL: 'CUSTOM_TEXT_EMAIL',
    ORDER_CANCELLATION: 'ORDER_CANCELLATION',
    DOUBLE_OPT_IN: 'DOUBLE_OPT_IN',
    INVITE_STORE_ADMIN: 'INVITE_STORE_ADMIN',
    ORDER_CONFIRMATION: 'ORDER_CONFIRMATION',
    ORDER_PARTIAL_REFUND: 'ORDER_PARTIAL_REFUND',
    SHIPPING_CONFIRMATION: 'SHIPPING_CONFIRMATION',
    REQUEST_SUPPORT: 'REQUEST_SUPPORT',
    MC_REQUEST_SUPPORT: 'MC_REQUEST_SUPPORT',
    GENERATED_PROMOCODES: 'GENERATED_PROMOCODES',
    SURVEY: 'SURVEY',
    USER_CONFIRMATION: 'USER_CONFIRMATION',
    USER_REQUEST_RESET_PASSWORD: 'USER_REQUEST_RESET_PASSWORD',
    STORE_OWNER_REQUEST_RESET_PASSWORD: 'STORE_OWNER_REQUEST_RESET_PASSWORD',
    VIP_CANCELLATION: 'VIP_CANCELLATION',
    VIP_CLUB_CONFIRMATION: 'VIP_CLUB_CONFIRMATION'
};
//# sourceMappingURL=emailPayload.js.map